import { Box, Container, Typography, Divider } from "@mui/material";
import { BlockMath } from 'react-katex';
import AuthorPopover from "./AuthorPopover";
import 'katex/dist/katex.min.css';
function Intro() {
    return (
        <div>
            <Container maxWidth="lg" sx={{ py: 4 }}>
                <Box sx={{ textAlign: 'left' }}>
                    <Typography
                        variant="h2"
                        sx={{
                            fontFamily: 'Inter, sans-serif',
                            fontWeight: 600,
                            fontSize: { xs: '1rem', sm: '2rem', md: '3rem' },
                            width: '100%',
                        }}
                    >
                        iPSC-CM Proteomics Data Viewer Webtool
                    </Typography>
                    <Divider
                        sx={{
                            width: '100%',
                            height: '1px',
                            backgroundColor: '#D3D3D3',
                            margin: '0 auto',
                            mt: 2,
                            mb: 2,
                            opacity: 0.5,
                        }}
                    />
                    <Typography variant="body1" sx={{ mb: 2 }}>
                        {`This is an interactive webtool designed to allow the user to explore the iPSC proteomics data set for the publication titled: `}
                    </Typography>

                    <Typography variant="body1" fontWeight={700} sx={{ mb: 2 }}>
                        {`Contractility Drives Cardiomyocyte Maturation and the Response to Nanopatterns`}
                    </Typography>
                    <Typography variant="body1" fontWeight={700} sx={{ mb: 2 }}>
                        Authors: Laura A. Sherer<sup>1*</sup>, Abigail Nagle<sup>3*</sup>, Maria Papadaki<sup>2</sup>, Seby L. Edassery<sup>2</sup>, Timothy S. McMillen<sup>4</sup>, Dasom Yoo<sup>4</sup>, Lauren D’Amico<sup>4</sup>, Daniel Brambila-Diaz<sup>4</sup>, Lucy Maynard<sup>4</sup>, Mark Qiao<sup>1</sup>, Jennifer Davis <sup>3,4</sup> Michael Regnier<sup>4</sup>, {' '} <AuthorPopover> </AuthorPopover>
                    </Typography>
                    <Typography sx={{ mb: 2 }}>
                        *Contributed Equally to This Work
                    </Typography>
                    <Typography>
                        Affiliations:
                    </Typography>
                    <Typography >
                        1. Department of Medicine, Section of Cardiology, Biological Sciences Division, University of Chicago, Chicago, IL
                    </Typography>
                    <Typography>
                        2. Department of Cell and Molecular Physiology, Loyola University Stritch School of Medicine, Maywood, IL
                    </Typography>
                    <Typography>
                        3. Department of Laboratory Medicine and Pathology, University of Washington, Seattle, WA
                    </Typography>
                    <Typography sx={{ mb: 2 }}>
                        4. Department of Bioengineering, University of Washington, Seattle, WA
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                        {`iPSCs with homozygous D65A cardiac Troponin C (cTnC) modifications were differentiated into 
                        cardiomyocytes and matured up to 60 days. This modification prevents cTnC from binding to calcium in the N-terminal 
                        regulatory site II. As a result, the troponin complex does not undergo the conformational change that allows 
                        tropomyosin to move away from myosin binding sites on the thin filament, preventing sarcomere contraction. 
                        Mass spectrometry was performed at Days 5, 7, 14, 30, and 60. In addition, another cohort of samples was replated onto 
                        nanopatterned surfaces at Day 46 and assessed via mass spectrometry on Day 60.`}
                    </Typography>
                    <Typography sx={{ mb: 2 }}>
                        {`This webtool currently allows for users to explore singular protein expression profiles, 
                        search for proteins in volcano plots at different time points, and also compare multiple different
                        proteins at different time points. More features may be introduced in the future. Almost everything on the plots
                        are interactive. Click and drag to zoom, double click to zoom out, and click on legend markers to highlight or remove traces.`}
                    </Typography>

                    <Typography sx={{ mb: 2 }}>
                        As a note, all error bars displayed in this webtool were calculated using the following formula:
                        <BlockMath math="\text{SEM} = \frac{\text{CV\%} \times \bar{x}}{100 \times \sqrt{n}}" />
                        Additionally, all p-value indicators use the same threshold:
                        <Typography align="center" component="div">
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 1 }}>
                                <Box> <strong>***</strong> for p &lt; 0.001 </Box>
                                <Box> <strong>**</strong> for p &lt; 0.01 </Box>
                                <Box> <strong>*</strong> for p &lt; 0.05 </Box>
                                <Box> <strong>n.s.</strong> for not significant </Box>
                            </Box>
                        </Typography>
                    </Typography>
                    <Typography sx={{ mb: 2 }}>
                        {`Each dropdown menu is populated based on the proteins detected in its corresponding mass spectrometry run. Since these runs were 
                        conducted on different days and may yield slightly different protein sets, the dropdowns may not all contain the same proteins. 
                        As a result, you might find a specific protein available in one dropdown but missing from others, depending on which dataset (or sheet) 
                        the plot is based on.`}
                    </Typography>





                </Box>
            </Container>
        </div>
    );
}

export default Intro;
//